export const performFederatedLogout = async (authEndpoint: string) => {
    try {
        await globalThis.fetch(`${authEndpoint}/signout?callbackUrl=/`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: await globalThis.fetch(`${authEndpoint}/csrf`).then(rs => rs.text()),
        });
    } catch (error) {
        // Suppress error
    }
};
